"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { FC, useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import { Article, ArticleSorting, DHubIntroProps, ImageElement } from "@/types";

import loadArticles from "../ArticleListing/loadArticles";
import DynamicImport from "../dynamicImport";
import DHubArticles from "./DHubArticles";

export interface Props {
  entry: DHubIntroProps;
  component?: any;
}

const DHubIntro: FC<Props> = ({ entry }) => {
  const t = useTranslations();
  const [isSo, setIsSo] = useState<boolean>(false);
  const locale = useLocale();
  const [articles, setArticles] = useState<Article[]>(entry.articleList ? entry.articleList : []);
  useEffect(() => {
    if (typeof window !== "undefined") {
      const value = localStorage?.getItem("isSo");
      if (value) {
        setIsSo(value === "true");
      }
    }
  }, []);

  const pathname = usePathname();

  const isHomePage = pathname === "/" || pathname === `/${locale}/`;
  if (isSo && isHomePage) {
    return null;
  }

  return (
    <div className="p-m md:p-0' w-full md:w-20\/24 mx-auto my-xl">
      <div>
        <Image src={entry.logo.url} alt={entry.logo.title || ""} width={180} height={65} className="mx-auto" />
      </div>
      <Tabs>
        <TabList className="my-l text-center">
          <Tab key="tab-all">{t("all")}</Tab>
          {entry.tabs.map((tab, index) => (
            <Tab
              key={`tab-${index}`}
              onClick={() => {
                loadArticles(5, tab.articlesType, tab.sorting === ArticleSorting.featured).then((res) => {
                  setArticles(res);
                });
              }}
            >
              <span className="capitalize">{tab.title}</span>
            </Tab>
          ))}
        </TabList>
        <TabPanel key={`tab-all`}>
          <DHubArticles articles={entry.articleList} fallbackImage={entry.fallbackImage} />
          {!!entry.cta && (
            <div className="text-center mt-xl">
              <Button
                href={getLink(entry.cta, locale)}
                size={ButtonSize.MEDIUM}
                variant={ButtonVariant.PRIMARY}
                theme={ButtonTheme.BLACK}
                customClass="inline-block"
              >
                {entry.cta.label}
              </Button>
            </div>
          )}
        </TabPanel>
        {/* TabPanels for each tab */}
        {entry.tabs.map((tab: any, index) => (
          <TabPanel key={`panel-${index}`}>
            {!tab.component || tab.component.length === 0 ? (
              <DHubArticles articles={articles} fallbackImage={entry.fallbackImage} />
            ) : (
              <DynamicImport key={`dynamic-${index}`} components={tab.component} locale={locale} target={tab.cta?.link?.target || "_self"} />
            )}
            {/* {tab.component?.length === 0 && <DHubArticles articles={articles} fallbackImage={entry.fallbackImage} />}

            {tab.component?.map((component: any, compIndex: any) => (
              <DynamicImport key={`component-${index}-${compIndex}`} components={[component]} locale={locale} />
            ))} */}
            {!!tab.cta && (
              <div className="text-center mt-xl">
                <Button
                  href={getLink(tab.cta, locale)}
                  size={ButtonSize.MEDIUM}
                  variant={ButtonVariant.PRIMARY}
                  theme={ButtonTheme.BLACK}
                  customClass="inline-block"
                >
                  {tab.cta.label}
                </Button>
              </div>
            )}
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
};

export default DHubIntro;
